import {BFormGroup, BFormInput, BTable} from "bootstrap-vue";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  components: {
    BFormGroup, BFormInput, BTable,ProductSearch
  },
  name: 'SetForm',
    props: {
      value: {
        type: Object,
        default: () => ({ name: '', products: [] })
      },
      mode: { default: 'create', type: String },
      products: { type: Array, default: () => [] },
      url: String
  },
  data() {
     return {
      productSet: this.createClone(this.value),
      disabled: false,
      productSelect: null,
      tableBusy: false,
      fields: [
        { key: 'id', label: 'شناسه' },
        { key: 'title', label: ' عنوان' },
        { key: 'delete', label: 'حذف' },
      ],
    }
  },
  watch: {
    value(newVal) {
      this.productSet = this.createClone(newVal)
    }
  },
  methods: {
    createClone(obj) {
      const clone = {
        name: obj && obj.name ? obj.name : '',
        products: Array.isArray(obj && obj.products) ? obj.products.map(p => ({
          id: p.id,
          title: p.title
        })) : []
      }
      return clone
    },

    setDisabled(val) {
      this.disabled = val
    },

    setProduct(item) {
      if (!item || !item.id) return

      const product = { id: item.id, title: item.title || item.name || '' }

      const exists = this.productSet.products.some(p => p.id === product.id)
      if (exists) {
        this.$root.notify('این محصول قبلا انتخاب شده است.', 'warning')
        return
      }

      this.productSet.products.push(product)

      this.$emit('input', this.createClone(this.productSet))
    },

    deleteItem(index) {
      window.swal({
        title: "آیتم حذف شود؟",
        text: "این عملیات غیر قابل بازگشت خواهد بود",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        dangerMode: true,
        buttons: ["خیر", "بله حذف کن"]
      })
      .then((willDelete) => {
        if (willDelete) {
          this.productSet.products.splice(index, 1)
          this.$emit('input', this.createClone(this.productSet))
        }
      })
      .catch(() => {})
    },

    async submit(e) {
      e.preventDefault()
      this.disabled = true
      try {
        let formData = new FormData(e.target)

        formData.append('_method', this.mode == 'edit' ? 'put' : 'post')

        const ids = this.productSet.products.map(p => p.id)
        ids.forEach(id => formData.append('product_ids[]', id))

        const response = await this.$axios.post(this.url, formData)
        this.$root.notify(response, 'success')
        this.$router.push('/admin/sets')
      } catch (error) {
        this.$root.notify(error)
      } finally {
        this.disabled = false
      }
    },
  }
}
